<template>
  <field-item
      :disabled="handler.isDisabled(dynamicInputProp, parentTreeContext)"
      @click="select(dynamicInputsSection.select(dynamicInputProp, path))"
  >
    <row>
      <prefix>
        <icon :glyph="dynamicInputGlyph(dynamicInputProp)"/>
      </prefix>
      <column>
        {{ dynamicInputProp.name }}
      </column>
    </row>
  </field-item>
</template>

<script lang="ts">
import Vue from 'vue';
import handlerComponentsMixin from '../mixins/handlerComponentsMixin';
import FieldItem from './common/field-item.vue';
import {ReferencePathNode} from "~/models/referencePaths/referencePathNode";
import DynamicInput from "~/models/dynamicInput";
import CertificateDynamicInput from "../../../../formability/certificateBuilder/models/certificateDynamicInput";
import ProcessFlowDynamicInputFieldsHandler from '~/models/dynamicFields/handlers/processFlows/processFlowDynamicInputFieldsHandler';
import ProcessFlowCertificateDynamicInputsHandler from "~/models/dynamicFields/handlers/processFlows/processFlowCertificateDynamicInputsHandler";
import {IDynamicTreeContext} from "~/interfaces/dynamicFieldsInterfaces";
import {ProcessFlowDynamicInputIcons} from "../../../../formability/certificateBuilder/enums/certificateDynamicInputType";

export default Vue.extend({
  mixins: [handlerComponentsMixin],
  components: {
    FieldItem,
  },
  props: {
    handler: {
      type: Object as () => ProcessFlowDynamicInputFieldsHandler | ProcessFlowCertificateDynamicInputsHandler,
      required: true,
    },
    dynamicInputProp: {
      type: Object as () => DynamicInput | CertificateDynamicInput,
      required: true,
    },
    path: {
      type: Array as () => ReferencePathNode[],
      default: () => {
        return [];
      },
    },
    parentTreeContext: {
      type: Object as () => IDynamicTreeContext,
      required: true,
    },
  },
  computed: {
    dynamicInputsSection() {
      return this.handler.dynamicInputsSection(this.lowerQ, this.dynamicInputProp);
    },
  },
  methods: {
    dynamicInputGlyph(dynamicInput: DynamicInput | CertificateDynamicInput): string {
      return ProcessFlowDynamicInputIcons[dynamicInput.type];
    },
  },
});
</script>